export default "__VITE_ASSET__804ee1d9__"